export enum LESSON_CONTENT_TYPE {
	VIDEO = 'video',
	TEXT = 'text',
	PRONOUNCE = 'pronounce',
  RECORD = 'record'
}
